var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.64143 .96773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 708.7,
    fill: "#006a44",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 236.2,
    y: 475.6,
    fill: "#c1272d",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb913",
    d: "M0 0h997.8v164.6H0z"
  }))));
}
export default "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBpZD0iZmxhZy1pY29ucy1sdCIgdmlld0JveD0iMCAwIDY0MCA0ODAiPgogIDxnIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIxcHQiIHRyYW5zZm9ybT0ic2NhbGUoLjY0MTQzIC45Njc3MykiPgogICAgPHJlY3Qgd2lkdGg9IjEwNjMiIGhlaWdodD0iNzA4LjciIGZpbGw9IiMwMDZhNDQiIHJ4PSIwIiByeT0iMCIgdHJhbnNmb3JtPSJzY2FsZSguOTM4NjUgLjY5Njg2KSIvPgogICAgPHJlY3Qgd2lkdGg9IjEwNjMiIGhlaWdodD0iMjM2LjIiIHk9IjQ3NS42IiBmaWxsPSIjYzEyNzJkIiByeD0iMCIgcnk9IjAiIHRyYW5zZm9ybT0ic2NhbGUoLjkzODY1IC42OTY4NikiLz4KICAgIDxwYXRoIGZpbGw9IiNmZGI5MTMiIGQ9Ik0wIDBoOTk3Ljh2MTY0LjZIMHoiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgLt as ReactComponent };